import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Connexion réussie");
      nav("/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Erreur de connexion");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center px-4">
      <div className="w-full max-w-md border border-zinc-800 p-10">
        <Link to="/" className="font-display text-2xl font-bold tracking-tight block mb-2">
          mixo<span className="text-red-500"> </span>vap
        </Link>
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-8">Connexion boutique</div>
        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="block text-xs font-mono uppercase tracking-widest text-zinc-500 mb-2">Email</label>
            <Input
              data-testid="login-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="rounded-none bg-zinc-900 border-zinc-800 focus-visible:ring-1 focus-visible:ring-red-500 focus-visible:ring-offset-0 focus-visible:border-red-500"
            />
          </div>
          <div>
            <label className="block text-xs font-mono uppercase tracking-widest text-zinc-500 mb-2">Mot de passe</label>
            <Input
              data-testid="login-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="rounded-none bg-zinc-900 border-zinc-800 focus-visible:ring-1 focus-visible:ring-red-500 focus-visible:ring-offset-0 focus-visible:border-red-500"
            />
          </div>
          <Button
            data-testid="login-submit"
            disabled={loading}
            className="w-full bg-red-500 hover:bg-red-600 rounded-none font-medium"
          >
            {loading ? "Connexion…" : "Se connecter"}
          </Button>
        </form>
        <div className="mt-6 text-sm text-zinc-500 text-center">
          <Link to="/forgot-password" data-testid="login-forgot-link" className="text-red-500 hover:text-red-400">
            Mot de passe oublié ?
          </Link>
        </div>
        <div className="mt-2 text-sm text-zinc-500 text-center">
          Pas encore de compte ?{" "}
          <Link to="/register" data-testid="login-register-link" className="text-red-500 hover:text-red-400">
            Créer un compte
          </Link>
        </div>
      </div>
    </div>
  );
}
